<template>
  <div>
    <div class="page_title flex_between">
      <span>
        <span>积分发放情况</span>
      </span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px">
      <div class="container">
        <el-tabs v-model="activeName">
          <el-tab-pane
            label="发放情况"
            name="1"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('2165') : false
            "
          ></el-tab-pane>
          <el-tab-pane
            label="使用情况"
            name="2"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('2167') : false
            "
          ></el-tab-pane>
          <div class="box">
            <div class="component">
              <keep-alive>
                <component :is="currentComponent" />
              </keep-alive>
            </div>
          </div>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
  <script>
import dayjs from "dayjs";
import ProvidePage from "./ProvidePage.vue";
import UsePage from "./UsePage.vue";
export default {
  data() {
    return {
      activeName: "1",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case "1":
          return ProvidePage;
        case "2":
          return UsePage;
        default:
          return ProvidePage;
      }
    },
  },
  created() {},
  methods: {
    back() {
      this.$router.back();
    },
  },
};
</script>
  <style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  min-height: calc(100vh - 140px);
}
</style>